import http, { httpShareBotInstance, imageCreationInstance, questionAnswerAiInstance, nanoBananaInstance } from './http'
const baseUrl = process.env.REACT_APP_IMAGE_CREATION_URL
function generateImage(data) {
  return http({
    method: 'POST',
    url: '/midjourney/imagine',
    data
  })
}
function generateNanoBananaImage(data) {
  return questionAnswerAiInstance({
    method: 'POST',
    url: '/?service=nano-banana',
    data,
    responseType: 'blob'
  })
}
function generateVideo(data) {
  return http({
    method: 'POST',
    url: '/midjourney/create',
    data
  })
}

function generateVariation(data) {
  return http({
    method: 'POST',
    url: '/midjourney/variation',
    data
  })
}

function upscaleImage(data) {
  return http({
    method: 'POST',
    url: '/midjourney/upscale',
    data
  })
}
function uploadMidjourneyImage(data) {
  return http({
    method: 'POST',
    url: '/midjourney/upload',
    data
  })
}

function conversationAI(data) {
  return httpShareBotInstance({
    method: 'POST',
    url: '/conversationalai',
    data
  })
}

function generateIdeogramImage(data) {
  return questionAnswerAiInstance({
    method: 'POST',
    url: '/?service=ideogram',
    data
  })
}

function fetchIGLastJob() {
  return imageCreationInstance({
    method: 'GET',
    url: baseUrl + `/v1/generation/job-history`,
  });
}
function fetchIGProgress(last_job_id) {
  return imageCreationInstance({
    method: 'GET',
    url: baseUrl + `/v1/generation/query-job?job_id=${last_job_id}`,
  });
}
function fetchImageGeneration(data) {
  return imageCreationInstance({
    method: 'POST',
    url: baseUrl + "/v2/generation/text-to-image-with-ip",
    data,
  });
}
function fetchImagePromptGeneration(data) {
  return imageCreationInstance({
    method: 'POST',
    url: baseUrl + "/v2/generation/image-prompt",
    data,
  });
}
function checkIGStatus() {
  return imageCreationInstance({
    method: 'GET',
    url: baseUrl + "/ping",
    timeout: 100000,
  });
}
function startIGLambda() {
  const baseUrl = process.env.REACT_APP_IMAGE_CREATION_LAMBDA_URL
  return imageCreationInstance({
    method: 'GET',
    url: `${baseUrl}?query=dog&aspect=100*100&output=1&format=png&style=Fooocus%20V2&seed=-1&verify=False&timeout=600000`,
  });
}
function stopIGLambda() {
  const baseUrl = process.env.REACT_APP_IMAGE_CREATION_LAMBDA_URL
  return imageCreationInstance({
    method: 'GET',
    url: `${baseUrl}?machine_state=turn_off`,
  });
}


export {
  generateImage,
  upscaleImage,
  generateVariation,
  conversationAI,
  generateIdeogramImage,
  fetchImageGeneration,
  fetchImagePromptGeneration,
  startIGLambda,
  stopIGLambda,
  checkIGStatus,
  fetchIGProgress,
  fetchIGLastJob,
  uploadMidjourneyImage,
  generateNanoBananaImage
}
